"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantDisplayTotal = void 0;
const getTotalVariantValue_1 = require("./getTotalVariantValue");
const getVariantDisplayTotal = (variant, exchange_rate) => {
    if (!exchange_rate || exchange_rate?.rate === 1)
        return 0;
    // format to two decimal places return as number
    return Math.floor((0, getTotalVariantValue_1.getTotalVariantValue)(variant) * exchange_rate.rate);
};
exports.getVariantDisplayTotal = getVariantDisplayTotal;
